export function toTitleCase(str) {
  if (str == null || str === '') return '';
  const lowerCasePrepositions = [
    'and',
    'but',
    'for',
    'nor',
    'or',
    'so',
    'the',
    'to',
    'in',
    'on',
    'at',
    'by',
    'with',
    'a',
    'an',
    'as',
    'of',
    'up',
    'down',
    'from',
    'about',
  ];

  return String(str)
    .split(/[\s_-]+/)
    .map((word, index, array) => {
      if (
        index === 0 ||
        index === array.length - 1 ||
        !lowerCasePrepositions.includes(word.toLowerCase())
      ) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
      return word.toLowerCase();
    })
    .join(' ');
}

/** Normalizes GetProductsByManagingBranch `status_counts` for stat cards. */
export function normalizeApiStatusCounts(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return null;
  }
  const out = {};
  for (const [key, val] of Object.entries(raw)) {
    const n = Number(val);
    if (!Number.isNaN(n) && n >= 0) {
      out[key] = n;
    }
  }
  return Object.keys(out).length ? out : null;
}

export function buildProductStatCardsFromCounts(getCount) {
  const rejectedTotal =
    getCount('admin_rejected') +
    getCount('merchant_rejected') +
    getCount('content_rejected_by_admin') +
    getCount('image_rejected_by_admin') +
    getCount('content_rejected_by_merchant') +
    getCount('image_rejected_by_merchant') +
    getCount('inactive');
  return [
    { label: 'Approved', value: getCount('approved') + getCount('active'), tone: 'approved' },
    {
      label: 'Merchant review pending',
      value:
        getCount('merchant_review_pending') + getCount('ai_generated_merchant_review_pending'),
      tone: 'pending',
    },
    { label: 'Admin review pending', value: getCount('admin_review_pending'), tone: 'pending' },
    // {
    //   label: 'Content review pending',
    //   value: getCount('merchant_content_review_pending'),
    //   tone: 'pending',
    // },
    // {
    //   label: 'Image review pending',
    //   value: getCount('merchant_image_review_pending'),
    //   tone: 'pending',
    // },
    { label: 'Rejected', value: rejectedTotal, tone: 'rejected' },
  ];
}

export function formatLastRefresh(timestamp) {
  if (!timestamp) return 'Never';
  try {
    return new Date(timestamp).toLocaleString([], {
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return 'Never';
  }
}

export function formatProductTypeLabel(type) {
  if (type === 'non_meal_item') return 'Regular';
  if (type === 'meal_item') return 'Combo';
  if (type === 'None') return 'None';
  return toTitleCase(String(type || '').replace(/_/g, ' '));
}

export function getKitchenProductsLayoutStyles(isCompactLayout) {
  return {
    controlBarStyle: {
      display: 'flex',
      flexDirection: 'column',
      gap: isCompactLayout ? '8px' : '0',
      marginBottom: '16px',
      background: '#ffffff',
      border: '1px solid #d7e0f2',
      borderRadius: '10px',
      boxShadow: '0 4px 14px rgba(15, 23, 42, 0.06)',
      padding: '16px',
    },
    topRowStyle: {
      display: 'flex',
      alignItems: isCompactLayout ? 'stretch' : 'center',
      justifyContent: 'space-between',
      gap: '12px',
      flexWrap: isCompactLayout ? 'wrap' : 'nowrap',
      width: isCompactLayout ? '100%' : 'auto',
    },
    filterGroupStyle: {
      display: 'flex',
      alignItems: isCompactLayout ? 'stretch' : 'center',
      gap: '12px',
      flexWrap: isCompactLayout ? 'wrap' : 'nowrap',
      flex: '1 1 auto',
      minWidth: 0,
    },
    lastRefreshInlineStyle: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '6px',
      fontSize: '12px',
      color: '#6f6f6fff',
      flexShrink: 0,
      alignSelf: 'center',
    },
    bottomRowStyle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      flexWrap: isCompactLayout ? 'wrap' : 'nowrap',
    },
    headerRowStyle: {
      display: 'flex',
      alignItems: isCompactLayout ? 'stretch' : 'center',
      justifyContent: 'space-between',
      gap: '12px',
      flexWrap: isCompactLayout ? 'wrap' : 'nowrap',
      marginBottom: '14px',
    },
  };
}
